
    import __i18nConfig from '@next-translate-root/i18n'
    import __loadNamespaces from 'next-translate/loadNamespaces'
    import Layout from "../../../components/Layout";
import PostPage from "../../../components/PostPage";
import { useGetSearchPostInPageQuery } from "../../../generated/graphql";
import { InferredPost } from "../../../types";
import Loader from "../../../components/Loader";
import { Text } from "rebass/styled-components";
import theme from "../../../styles/theme";
import useTranslation from "next-translate/useTranslation";
interface Props {
    isMobile: boolean;
    searchValue: string;
    pageNum: number;
    offset: number;
    batchSize: number;
}
function SearchPage(props: Props) {
    const { isMobile, searchValue, pageNum, offset, batchSize } = props;
    const { t } = useTranslation("common");
    const { data, loading } = useGetSearchPostInPageQuery({
        variables: { search: searchValue, offset: offset, size: batchSize },
    });
    const posts: InferredPost[] = data?.posts?.nodes || [];
    const totalPosts: NonNullable<number> = data?.posts?.pageInfo.offsetPagination?.total || 0;
    return (<>
      {loading ? (<Loader />) : (<Layout>
          {posts.length === 0 ? (<Text as="p" sx={theme.title}>
              {`${t("noResults")} ${searchValue}`}{" "}
            </Text>) : (<>
              <Text as="h1" sx={{ ...theme.mainTitle, mb: "32px" }}>
                {`${t("searchResults")} ${searchValue}`}
              </Text>
              <PostPage basePath="/" afterPath={`?s=${encodeURIComponent(searchValue)}`} posts={posts} isMobile={isMobile} pageSelected={pageNum} totalPosts={totalPosts}/>
            </>)}
        </Layout>)}
    </>);
}
export default SearchPage;

    async function __Next_Translate__getServerSideProps__1976e6e07f0__(ctx) {
      
      return {
        
        
        props: {
          
          ...(await __loadNamespaces({
            ...ctx,
            ...__i18nConfig,
            pathname: '/page/[pageNum]/SearchPage',
            loaderName: 'getServerSideProps',
            loadLocaleFrom: __i18nConfig.loadLocaleFrom || ((l, n) => import(`@next-translate-root/locales/${l}/${n}`).then(m => m.default)),
          }))
        }
      }
    }
    export { __Next_Translate__getServerSideProps__1976e6e07f0__ as getServerSideProps }
  